<template>
  <div class="col-12">
    <div class="col-12">
      <!-- <b-btn
      class="float-right"
        type="button"
        @click="go_back()"
      >
        Back
      </b-btn> -->
      <h5>Sell Animal
        <b-btn
          class="btn-danger float-right"
           style="text-align: right;"
          @click="go_back()"
        >
         <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
        </b-btn>
    </h5>
    </div><br/>

    <div class="col-12" style="margin-top: 30px">
        <b-card>
      <b-card-text class="mycard">
      <center>
        <img src="../../assets/114.jpg" height="200px" /><br />
        <!-- <h7><b>Tag No:29</b></h7
          ><br />
          <h7><b>Type:cow</b></h7
          ><br />
          <h7><b>Amount:20000</b></h7
          ><br />
          <h7><b>Breed:</b></h7
          ><br />
          <h7><b>Age:</b></h7
          ><br />
          <h7><b>Daily Milk:</b></h7>
        </left> -->
        </center>
        <div class="row">
          <div class="col-12">
            <table style="" width="100%" border="0"><br />
              <!-- <tr>
                    <td   style="text-align: left">Tag No</td>
                    <td   style="text-align: left">:</td>
                    
                    <td   style="text-align: left">29</td>
                  </tr> -->
              <tr>
                <td width="45%" style="text-align: left">Tag No</td>
                <td width="1%" style="text-align: left">:</td>
                <td width="54%" style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td style="text-align: left">Type</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td style="text-align: left">Breed</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td style="text-align: left">Breed Name</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td style="text-align: left">Age</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td style="text-align: left">Amount</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="number"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td style="text-align: left">In Milking Days</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td style="text-align: left">Milking Yield</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td style="text-align: left">Is Pregnant</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td width="60%" style="text-align: left">No of Parturition</td>
                <td style="text-align: left">:</td>
                <td width="39%" style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td style="text-align: left">Pregnancy month</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td style="text-align: left">Is Calve</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td style="text-align: left">Last Calve Date</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="date"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>
              
              <tr>
                <td style="text-align: left">Last Calve Gender</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="text"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                </td>
              </tr>

              <br>
                   <tr>
                <td colspan="3" style="text-align:center;" >  <button
          type="button"
          class="btn btn-xs btn-primary col-12"
          @click="send_enquiry1"
        >
          Send Request for Medical Certificate
        </button> </td>
      
            </tr>
              <tr>
                <td colspan="3" style="text-align:center;" > OR </td>
      
            </tr>
              <tr>
                <td style="text-align: left">Upload Certificate</td>
                <td style="text-align: left">:</td>
                <td style="text-align: left">
                  <input
                    class="form-control"
                    type="file"
                    id="Tname"
                    name="aname"
                    autocomplete="off"
                  />
                 
                </td>
              </tr>
            </table>
          </div>
        </div>
      </b-card-text>
      </b-card>
      <div class="btn-group col-10">
        <button
          type="button"
          class="btn btn-xs btn-primary col-6"
          @click="send_enquiry"
        >
          Submit</button
        >&nbsp;
        <button
          type="button"
          class="btn btn-xs btn-primary col-6"
          @click="add_to_cart"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
    go_back() {
      this.$router.go(-1);
    },
    add_to_cart() {
      alert("reset all data sucessfully");
    },
    send_enquiry() {
      alert("submit sucessfully");
    },
    send_enquiry1() {
      alert("Request Send sucessfully");
    },
  },
};
</script>